import { render, staticRenderFns } from "./martialTree.vue?vue&type=template&id=f31e58be&scoped=true&"
import script from "./martialTree.vue?vue&type=script&lang=js&"
export * from "./martialTree.vue?vue&type=script&lang=js&"
import style0 from "./martialTree.vue?vue&type=style&index=0&id=f31e58be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31e58be",
  null
  
)

export default component.exports